import {ArtworkState} from "../definitions/types";
import {useContentUpload} from "./useFileUpload";
import {useArtwork} from "../redux/stateHooks";
import {useCustomerArtworkQuery} from "./useCustomerArtworkQuery";

/**
 * Creates a new artwork if the product is text only and has artwork notes
 * @param isTextOnly - Whether the product is text only
 * @param artwork - The artwork state from redux
 * @returns The artwork id if the product is text only and has artwork notes, otherwise null. If the product is not text only, returns undefined.
 */
export function useCreateTextOnlyArtwork() {
    const {model: {isTextOnly}} = useCustomerArtworkQuery();
    const artwork = useArtwork();
    const {uploadArtworkNotes} = useContentUpload();
    return {
        createTextOnlyArtwork: async () => {
            return isTextOnly ?
                // If the product is text only and has artwork notes, create a new artwork with the notes
                artwork?.notes ? await uploadArtworkNotes() : null :
                // Regular products will pass undefined to the createItem function
                // This will tell it to use the existing artwork data in redux
                undefined;
        }
    }
}